import { AppServices } from "@singularsystems/neo-core"
import { AppService, AppTypes } from 'st-app/Services/AppService';
// TODO - In Mono Repo just use AppTypes.Dividends below instead of DividendsSharedTypes. I needed to do this because Dividends/ParticipantsApp is part of AdminApp!

import { Config } from "st-app/Models/Config/Config";

const Types = {
    ...AppTypes,
    Dividends: {
        ApiClients: {
            ...AppTypes.Dividends.ApiClients,
        }
    },
    Config: AppServices.NeoTypes.Config.ConfigModel.asType<Config>()
}

export { AppService, Types}
